import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ButtonWrapper,
  StyledBox,
  StyledBoxBorder,
  StyledBoxCard,
  StyledBoxColorInfo,
  StyledBoxFlex,
  StyledGrid,
  StyledTypography,
  StyledTypographyGroupCart,
  StyledTypographyLabel,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import profile from "../../../assets/images/vector-shop-icon.png";
import theme from "../../../theme";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import Grid from "@mui/material/Grid2";
import CustomInput from "../../common/input/CustomInput";
import {
  StyledBoxStart,
  StyledInputAdornment,
  StyledTypographyRup,
} from "../product-details/style";
import { StyledBoxAuto } from "../auto-split-calculation/style";

export default function ManualSplit({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <img src={profile} alt="profile" loading="lazy" />

            <StyledTypography>Auto Split Cost Calculation</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <StyledBoxAuto>
          <StyledBoxColorInfo>
            <StyledTypographyGroupCart>
              Group cart information
            </StyledTypographyGroupCart>
            <Grid container spacing={1}>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Cart name:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  Summer Shopping Group
                </StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Timeline:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  7 days
                </StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Payment Option:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  Auto Split
                </StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Members:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  3 people
                </StyledTypographyLabel>
              </Grid>
            </Grid>
          </StyledBoxColorInfo>
          <StyledBoxBorder>
            <StyledTypographyGroupCart>
              Manual Split cost calculation
            </StyledTypographyGroupCart>

            <Grid container alignItems="center" spacing={2}>
              <StyledGrid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Renny Thomas</StyledTypographyLabel>
                <StyledTypographyLabel
                  color={theme.palette.custom.orderButtonColor}
                >
                  $21.80
                </StyledTypographyLabel>
              </StyledGrid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <CustomInput
                  issize="true"
                  type="number"
                  color={theme.palette.custom.productTextColor}
                  fontSize={theme.typography.regular.fontSize}
                  height="10px"
                  placeholder="0.00"
                  startAdornment={
                    <StyledBoxStart>
                      <StyledInputAdornment position="start">
                        <StyledTypographyRup>$</StyledTypographyRup>
                      </StyledInputAdornment>
                    </StyledBoxStart>
                  }
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" spacing={2}>
              <StyledGrid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Sunny Thomas</StyledTypographyLabel>
                <StyledTypographyLabel
                  color={theme.palette.custom.orderButtonColor}
                >
                  $15.90
                </StyledTypographyLabel>
              </StyledGrid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <CustomInput
                  issize="true"
                  type="number"
                  border={theme.borders.boxBorder}
                  color={theme.palette.custom.productTextColor}
                  fontSize={theme.typography.regular.fontSize}
                  height="10px"
                  placeholder="0.00"
                  startAdornment={
                    <StyledBoxStart>
                      <StyledInputAdornment position="start">
                        <StyledTypographyRup>$</StyledTypographyRup>
                      </StyledInputAdornment>
                    </StyledBoxStart>
                  }
                />
              </Grid>
            </Grid>
          </StyledBoxBorder>
        </StyledBoxAuto>

        <ButtonWrapper>
          <CustomButton
            padding="10px 64px"
            fontSize={theme.typography.regular.fontSize}
            height="44px"
            btnLabel="Close"
            btntype={"white"}
            color={theme.palette.custom.lockerValueColor}
            fontWeight={theme.typography.fontWeight.medium}
            border={theme.borders.defaultButton}
            onClick={() => handleClose()}
          />
          <CustomButton
            padding="10px 37px"
            btntype={"primary"}
            color={theme.palette.custom.white}
            btnLabel={"Continue"}
          />
        </ButtonWrapper>
      </StyledBox>
    </Modal>
  );
}
